import { useState } from 'react';
import { useFetch } from './useFetch';
import { useNavigate } from 'react-router-dom';
import { apiConfig } from '../api/apiConfig';
import { useAuthToken } from './useAuthToken';
import { useCart } from '../context/CartContext';
import moment from 'moment';
import { isNumeric } from 'jquery';
import { ensurePlaceToPayLoaded } from '../utils/paymentSdkLoader';
// Hook para gestionar planes
export const useGetCourse = () => {
  const [, handleFetch] = useFetch();
  const [mpPreferenceCourse] = useState('null');
  const navigate = useNavigate();
  const { authToken } = useAuthToken();
  const { setOpen, clearCart } = useCart();
  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
  // helper to mark the course as taken (always use provider 1)
  const takeCourse = async (courseId) => {
    if (!authToken) return Promise.resolve();
    if (!courseId) return Promise.resolve();
    try {
      const resp = await handleFetch({
        url: `courses/take/1/${courseId}`,
        method: 'POST',
        headers: { Authorization: `Bearer ${authToken}` },
      });

      // from resp extract content provider user id (user_id) and create a user study
      const contentProviderUserId = resp?.user_id || resp?.userId || resp?.user_id;
      if (contentProviderUserId) {
        if (String(courseId).startsWith('plan-estudios')) {
          const studyPayload = {
            studyTypeId: '1',
            contentProviderId: '1',
            status: 'not_started',
            progress: 0,
            avgScore: 0,
            userId: contentProviderUserId,
            studyId: courseId,
            contentProviderUserId: contentProviderUserId,
          };
          try {
            await handleFetch({
              url: 'courses/user_studies',
              method: 'POST',
              data: studyPayload,
              headers: { Authorization: `Bearer ${authToken}` },
            });
          } catch (e2) {
            console.log('courses/user_studies failed', e2);
          }
        } else {
          console.log('takeCourseAndCreateStudy: no user_id in response', resp);
        }
      } else {
        console.log('takeCourse: no user_id in response', resp);
      }
      return resp;
    } catch (e) {
      console.log('courses/take failed', e);
      throw e;
    }
  };
  const _assignmentPromises = new Map(); // key -> Promise
  const _assignedCache = new Set(); // keys that were assigned successfully or detected
  const postUserCourseWithRetries = async (payload, maxRetries = 2, baseDelay = 500) => {
    if (!payload || !payload.userId || !payload.courseId) return null;
    const key = `${payload.userId}:${payload.courseId}`;
    if (_assignedCache.has(key)) {
      console.log('assignment already recorded in cache, skipping POST', key);
      return { alreadyAssigned: true };
    }
    if (_assignmentPromises.has(key)) {
      console.log('returning existing in-flight assignment promise for', key);
      return _assignmentPromises.get(key);
    }
    let attempt = 0;
    const work = (async () => {
      try {
        const checkResp = await handleFetch({
          url: 'users/plans/users_courses/current',
          method: 'POST',
          data: {
            companyId: payload.companyId || apiConfig.company,
            userId: payload.userId,
            courseId: payload.courseId,
          },
          headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
        }).catch(() => null);
        if (checkResp) {
          console.log('user already has course, skipping assign', payload.courseId, payload.userId);
          _assignedCache.add(key);
          return checkResp;
        }
      } catch (e) {
        console.log('users_courses current check failed, proceeding to post', e);
      }

      while (attempt <= maxRetries) {
        try {
          const res = await handleFetch({
            url: 'users/plans/users_courses',
            method: 'POST',
            data: payload,
          });
          // mark as assigned in cache
          _assignedCache.add(key);
          return res;
        } catch (err) {
          const status = err?.status || err?.response?.status || err?.statusCode;
          console.log(`post users_courses attempt ${attempt} failed`, status, err);
          if ((status === 500 || status === '500') && attempt < maxRetries) {
            attempt++;
            await sleep(baseDelay * attempt);
            continue;
          }
          throw err;
        }
      }
      return null;
    })();

    _assignmentPromises.set(key, work);
    try {
      const r = await work;
      return r;
    } finally {
      _assignmentPromises.delete(key);
    }
  };
  // Handle envío de información a mercagopago
  const mpOldPayment = (data, recurring = false) => {
    const action = recurring ? 'subscription' : 'preference';
    handleFetch({
      url: `payments/mp_${action}`,
      method: 'POST',
      data,
    }).then((p) => {
      window.location.replace(p.init_point);
    });
  };
  const mpPayment = async (data) => {
    let ip = '';
    await fetch('https://api64.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => {
        ip = data.ip;
      })
      .catch((error) => console.error('Error al obtener la IP:', error));
    const currentDate = new Date();
    currentDate.setMinutes(currentDate.getMinutes() + 30);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const senddata = {
      course: {
        name: data.fields?.[0]?.['name'] || '',
        currency: 'COP',
        price: (data.fields || []).reduce((sum, item) => sum + parseFloat(item.price || 0), 0),
      },
      reference: `${year}${month}${day}-curso-${data.user.id}`,
      ip: ip,
      userAgent: window.navigator.userAgent,
      buyer: {
        name: data.user.name,
        surname: data.user.lastname,
        documentType: data.user.documentType,
        document: data.user.document,
        email: data.user.email,
        mobile: data.user.phone,
      },
      fields: (data.fields || []).map((c) => ({
        keyword: `${c['name']} COP: ${c['price']}`,
        value: `${year}${month}${day}-curso-${data.user.id}`,
        displayOn: 'both',
      })),
    };
    let requestOptions = {
      method: 'POST',
      headers: Object.assign({}, apiConfig.header, {}),
      body: JSON.stringify(senddata),
    };
    await fetch(`${apiConfig.baseUrl}payments/placetopay`, requestOptions)
      .then(async (resp) => {
        const response = await resp.json();
        associateErrorCourse(data.user, data.fields?.[0], 1, response.requestId);
        await ensurePlaceToPayLoaded();
        window.P.init(response.processUrl);
        window.P.on('response', function (response) {
          let promise = new Promise((resolve) => {
            handleFetch({
              url: `payments/webhookptp`,
              method: 'POST',
              data: {
                requestId: response.requestId,
              },
            }).then(
              (r) => {
                const price =
                  r.request &&
                  r.request.payment &&
                  r.request.payment.amount &&
                  r.request.payment.amount.total
                    ? r.request.payment.amount.total
                    : undefined;
                const currency =
                  r.request &&
                  r.request.payment &&
                  r.request.payment.amount &&
                  r.request.payment.amount.currency
                    ? r.request.payment.amount.currency
                    : undefined;
                const authorization =
                  r.payment && r.payment[0] && r.payment[0].authorization
                    ? r.payment[0].authorization
                    : undefined;
                const reference =
                  r.request && r.request.payment ? r.request.payment.reference : undefined;
                resolve({
                  status: r.status.status,
                  date: moment.utc(r.status.date).format('DD/MM/YYYY'),
                  price: price,
                  currency: currency,
                  authorization: authorization,
                  reference: reference,
                });
              },
              () => resolve(false)
            );
          });
          promise.then((value) => {
            setOpen(false);
            if (response.status.status === 'APPROVED') {
              navigate(
                `/cuenta-creada?&status=approved&external_reference=${data.user.id}-${data.fields?.[0].courseId}&payment_id=${response.reference}&merchant_order_id=${response.reference}&requestId=${response.requestId}`,
                {
                  state: {
                    course: data.fields?.[0],
                    user: data.user,
                    toastProperties: {
                      show: true,
                      type: 'success',
                      title: 'Se ha completado la operación exitosamente',
                      message: `<b>Datos de la operación</b>
                            <br><b>Estado</b>: ${value.status || '-'} 
                            <br><b>Fecha</b>: ${value.date} 
                            <br><b>Monto</b>: ${value.price || '-'} 
                            <br><b>Moneda</b>: ${value.currency || '-'} 
                            <br><b>Autorización/CUS</b>: ${value.authorization || '-'} 
                            <br><b>Referencia de pago</b>: ${value.reference || '-'}`,
                      duration: 25000,
                      position: { horizontal: 'right', vertical: 'top' },
                    },
                  },
                }
              );
            } else if (response.status.status === 'PENDING') {
              //associateErrorCourse(data.user,data.course,1,response.requestId)
              navigate('/', {
                state: {
                  toastProperties: {
                    show: true,
                    type: 'pending',
                    title: 'La petición se encuentra pendiente',
                    message: `El pago está en proceso de revisión, serás notificado al finalizar la operación.<br><br>
                                <b>Datos de la operación</b>
                                <br><b>Estado</b>: ${value.status || '-'} 
                                <br><b>Fecha</b>: ${value.date} 
                                <br><b>Monto</b>: ${value.price || '-'} 
                                <br><b>Moneda</b>: ${value.currency || '-'} 
                                <br><b>Autorización/CUS</b>: ${value.authorization || '-'} 
                                <br><b>Referencia de pago</b>: ${value.reference || '-'}`,
                    duration: 25000,
                    position: { horizontal: 'right', vertical: 'top' },
                  },
                },
              });
            } else if (response.status.status === 'REJECTED') {
              associateErrorCourse(data.user, data.fields?.[0], 0, response.requestId);
              navigate('/', {
                state: {
                  toastProperties: {
                    show: true,
                    type: 'error',
                    title: 'Ha ocurrido un error realizando la operación',
                    message: `No pudo completarse la operación, por favor intenta nuevamente.<br><br>
                                <b>Datos de la operación</b>
                                <br><b>Estado</b>: ${value.status || '-'} 
                                <br><b>Fecha</b>: ${value.date} 
                                <br><b>Monto</b>: ${value.price || '-'} 
                                <br><b>Moneda</b>: ${value.currency || '-'} 
                                <br><b>Autorización/CUS</b>: ${value.authorization || '-'} 
                                <br><b>Referencia de pago</b>: ${value.reference || '-'}`,
                    duration: 25000,
                    position: { horizontal: 'right', vertical: 'top' },
                  },
                },
              });
            }
          });
        });
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
  // Handle para asignar plan a usuario, recibe por parámetro id de usuario, id de plan y código si completa operación por mercadopago
  const associateCourse = async (user, code = null, requestId) => {
    let planAssociated = 'assigned';
    let coursesFull = [];
    const processCodeAssignment = (codeObj, approvalCodeToUse) => {
      return new Promise((res) => {
        if (
          (codeObj && codeObj.courseId && codeObj.courseId.startsWith('plan-estudios')) ||
          (codeObj && codeObj.id && codeObj.id.toString().startsWith('plan-estudios')) ||
          (codeObj && codeObj.courseId && codeObj.courseId.startsWith('plan-de-estudios')) ||
          (codeObj && codeObj.id && codeObj.id.toString().startsWith('plan-de-estudios'))
        ) {
          handleFetch({
            url: `catalog/spcourses?studyplanId=${codeObj?.courseId || codeObj?.id}`,
            method: 'GET',
          })
            .then(async (crs) => {
              for (let i = 0; i < crs?.data?.length; i++) {
                await handleFetch({
                  url: 'catalog/spusers',
                  method: 'POST',
                  data: {
                    userId: user.id,
                    studyplanId: codeObj?.courseId || codeObj?.id,
                    courseId: crs?.data[i].courseId,
                    companyId: apiConfig.company,
                    certificated: false,
                  },
                });
                await postUserCourseWithRetries({
                  userId: user.id,
                  courseId: crs?.data[i].courseId,
                  approvalCode: `${approvalCodeToUse || ''}`,
                  companyId: apiConfig.company,
                });
              }
              await postUserCourseWithRetries({
                userId: user.id,
                courseId: codeObj?.courseId || codeObj?.id,
                approvalCode: `${approvalCodeToUse || ''}`,
                companyId: apiConfig.company,
              });
              if (authToken) {
                await takeCourse(codeObj.courseId || codeObj.id).catch((e) => console.log('e', e));
              }
              res('assigned');
            })
            .catch((e) => {
              console.log('e', e);
              res('not_assigned');
            });
        } else {
          postUserCourseWithRetries({
            userId: user.id,
            courseId: codeObj.courseId || codeObj.id,
            approvalCode: approvalCodeToUse,
            companyId: apiConfig.company,
          })
            .then((courseResp) => {
              if (authToken) {
                return takeCourse(courseResp?.courseId).catch((e) => console.log('e', e));
              }
              return null;
            })
            .then(() => res('assigned'))
            .catch((err) => {
              console.log('assign course failed', err);
              const takePromise = authToken
                ? takeCourse(codeObj.courseId || codeObj.id).catch((takeErr) =>
                    console.log('courses/take failed after assign error', takeErr)
                  )
                : Promise.resolve();
              takePromise.finally(() => res('not_assigned'));
            });
        }
      });
    };

    try {
      if (isNumeric(requestId)) {
        try {
          const rc = await handleFetch({ url: `catalog?$limit=1000`, method: 'GET' });
          coursesFull = rc?.data || [];
        } catch (err) {
          console.log('catalog fetch failed', err);
          coursesFull = [];
        }
        try {
          const r = await handleFetch({
            url: `payments/webhookptp`,
            method: 'POST',
            data: { requestId: requestId },
          });
          const fields = r.request && r.request.fields && r.request.fields.slice(0, -2);
          const cleanKeywords = (fields || []).map((field) =>
            field.keyword.replace(/\sCOP:.*$/, '').trim()
          );
          const matchedCourses = coursesFull.filter((course) =>
            cleanKeywords.includes(course.name)
          );
          for (const course of matchedCourses) {
            await processCodeAssignment(course, requestId);
          }
          return planAssociated;
        } catch (err) {
          console.log('payments/webhookptp failed', err);
          if (code) {
            const result = await processCodeAssignment(code, requestId);
            return result === 'assigned' ? 'assigned' : 'not_assigned';
          }
          console.log('No code provided and webhook failed; cannot assign');
          return 'not_assigned';
        }
      } else {
        if (
          (code && code.courseId && code.courseId.startsWith('plan-estudios')) ||
          (code && code.id && code.id.toString().startsWith('plan-estudios')) ||
          (code && code.courseId && code.courseId.startsWith('plan-de-estudios')) ||
          (code && code.id && code.id.toString().startsWith('plan-de-estudios'))
        ) {
          try {
            const crs = await handleFetch({
              url: `catalog/spcourses?studyplanId=${code?.courseId || code?.id}`,
              method: 'GET',
            });
            for (let i = 0; i < crs?.data?.length; i++) {
              await handleFetch({
                url: 'catalog/spusers',
                method: 'POST',
                data: {
                  userId: user.id,
                  studyplanId: code?.courseId || code?.id,
                  courseId: crs?.data[i].courseId,
                  companyId: apiConfig.company,
                  certificated: false,
                },
              });
              await postUserCourseWithRetries({
                userId: user.id,
                courseId: crs?.data[i].courseId,
                approvalCode: `${requestId}`,
                companyId: apiConfig.company,
              });
            }
            await postUserCourseWithRetries({
              userId: user.id,
              courseId: code?.courseId || code?.id,
              approvalCode: `${requestId}`,
              companyId: apiConfig.company,
            });
            if (authToken) {
              await takeCourse(code.courseId).catch((e) => console.log('e', e));
            }
            return planAssociated;
          } catch (e) {
            console.log('e', e);
            return 'not_assigned';
          }
        } else {
          try {
            const courseResp = await postUserCourseWithRetries({
              userId: user.id,
              courseId: code.courseId || code.id,
              approvalCode: requestId,
              companyId: apiConfig.company,
            });
            if (authToken) {
              await takeCourse(courseResp?.courseId).catch((e) => console.log('e', e));
            }
            return planAssociated;
          } catch (err) {
            console.log('assign course failed', err);
            try {
              if (authToken) {
                await takeCourse(code.courseId || code.id).catch((takeErr) =>
                  console.log('courses/take failed after assign error', takeErr)
                );
              }
            } catch (ignored) {
              /* swallow */
            }
            return 'not_assigned';
          }
        }
      }
    } catch (e) {
      console.log('associateCourse unexpected error', e);
      return 'not_assigned';
    }
  };
  // Handle para asignar curso a usuario, recibe por parámetro id de usuario, id de curso y código si completa operación
  const associateErrorCourse = (user, course, errorType, requestId, companyId = 1) => {
    return new Promise((resolve) => {
      let planAssociated = 'not_assigned';
      handleFetch({
        url: 'users/plans/users_courses_review',
        method: 'POST',
        data: {
          userId: user.id,
          courseId: course.fields?.[0]?.id || course.id,
          errorType,
          requestId,
          companyId,
        },
      })
        .then(() => {
          resolve(planAssociated);
        })
        .catch(() => {
          planAssociated = 'not_assigned';
        })
        .finally(() => {
          resolve(planAssociated);
        });
    });
  };
  // Función para asociar curso según condición, recibe id usuario, id curso y pago recurrente
  const getCourse = (user, course, recurrent, pasarela) => {
    let today = new Date();
    let day = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
    let month = today.getMonth() < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1;
    let year = today.getFullYear();
    return new Promise((resolve) => {
      clearCart();
      setOpen(false);
      if (course.reduce((acc, item) => acc + (item.price || 0), 0) === 0) {
        course.forEach(async (c) => {
          await associateCourse(user, c, `Curso cortesia ${day}/${month}/${year}`).then((pa) =>
            resolve(pa)
          );
          navigate(`/`, {
            state: {
              toastProperties: {
                show: true,
                type: 'success',
                title: 'Curso aprobado',
                message: `Se ha asignado el curso a tu cuenta y ya puedes disfrutar de él.`,
                duration: 25000,
                position: { horizontal: 'right', vertical: 'top' },
              },
            },
          });
        });
      } else {
        const getSecureUrl = (url) => {
          if (url && url.startsWith('http://')) {
            return url.replace('http://', 'https://');
          }
          return url;
        };
        const data = {
          course: {
            ...course,
            returnUrl: getSecureUrl(apiConfig.mercadoPago.returnUrl),
            returnUrlBack: getSecureUrl(apiConfig.mercadoPago.returnUrlBack),
          },
          ...(course.length > 0 && {
            fields: course.map((c) => c).flat(),
          }),
          user,
        };
        if (pasarela === 'mercadopago') {
          mpOldPayment(data, recurrent);
        } else {
          mpPayment(data, recurrent);
        }
        resolve('purchase');
      }
    });
  };

  return { getCourse, associateCourse, mpPreferenceCourse };
};
